export default __webpack_public_path__ + "static/comments-f096938e60fb35e60947c7a9ae24c360.png";